import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import find from 'lodash/find';
import flatten from 'lodash/flatten';
import groupBy from 'lodash/groupBy';
import keys from 'lodash/keys';
import keyBy from 'lodash/keyBy';
import orderBy from 'lodash/orderBy';
import shuffle from 'lodash/shuffle';

//import { queryParams } from '../router/utils';

const allIds = state => state.entities.people.allIds;
const byId = state => state.entities.people.byId;
const teamsById = state => state.entities.team.byId;

const getAllPeople = createSelector([byId, allIds], (peopleById, ids) => {
  return ids.map(id => {
    const people = peopleById[id];
    return {
      ...people,
    };
  });
});

export const getPeopleByWPId = createSelector([getAllPeople], people => {
  return keyBy(people, person => person.id);
});

export const getPeopleByDiscipline = createSelector(
  [getAllPeople, teamsById],
  (people, teams) => {
    const groups = groupBy(people, 'team');

    return keys(groups)
      .sort()
      .map(key => {
        const team = teams[key];
        return {
          ...team,
          people: orderBy(groups[key], 'firstName', 'asc'),
        };
      });
  }
);

export const getPeopleByDisciplineFlat = createSelector(
  [getPeopleByDiscipline],
  people => {
    const mergedPeeps = flatten(people.map(group => group.people));
    if (mergedPeeps.length === 0) return [];
    return mergedPeeps;
  }
);

export const getPotentialColleaguesByCategory = createCachedSelector(
  getPeopleByDiscipline,
  (state, category) => category,
  (people, category) => {
    const categoryPeople = find(people, { slug: category });
    return categoryPeople
      ? orderBy(shuffle(categoryPeople.people).slice(0, 5), 'firstName', 'asc')
      : [];
  }
)((state, category) => category);
/*

export const getPeopleAlphabetically = createSelector(
  [getAllPeople],
  people => {
    return [
      {
        key: 'a-z',
        title: 'A-Z',
        people: orderBy(people, 'lastName', 'asc'),
      },
    ];
  }
);

export const getSortParam = createSelector([queryParams], params => {
  return params.sort || 'by-discipline';
});

export const getPeopleByQueryGrouped = createSelector(
  [getPeopleAlphabetically, getPeopleByDiscipline, getSortParam],
  (alphabetically, byDiscipline, sortParam) => {
    switch (sortParam) {
      case 'a-z':
        return alphabetically;
      default:
        return byDiscipline;
    }
  }
);

export const getPeopleByQuery = createSelector(
  [getPeopleByQueryGrouped],
  people => {
    const mergedPeeps = flatten(people.map(group => group.people));
    if (mergedPeeps.length === 0) return [];
    return mergedPeeps;
  }
);
*/



// WEBPACK FOOTER //
// ./src/modules/people/people.selectors.js